// extracted by mini-css-extract-plugin
module.exports = {"sm":"320px","xsm":"640px","md":"768px","lg":"980px","xl":"1280px","xxl":"1440px"};